import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import $enDigits from "@/mixins/enDigits";
import { ContactService, UserService } from "@/services";

const CountDown = () =>
  import(/* webpackChunkName: "count-down" */ "@/components/CountDown/index");

export default {
  name: "mobile-input",
  components: { CountDown },
  mixins: [$enDigits],
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    countryIsoExist: {
      type: Boolean,
      default: false
    },
    countries: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedCountry: null,
      baseURL: process.env.VUE_APP_BASE_URL_V4,
      mobileInput: "",
      mobileCode: "",
      isCountDownFinish: false,
      isRequesting: false,
      ttl: 0,
      // isModalOpen: false,
      mobileNumberRules: [
        v =>
          !!v ||
          this.$t(
            "accountPage.identityInformation.contactInfo.mobile.modals.getMobileNumber.subtitle"
          ),
        v =>
          /^(09)\d{9}/.test(v) ||
          this.$t(
            "accountPage.identityInformation.contactInfo.mobile.modals.getMobileNumber.mobileValidation.invalid"
          )
      ]
    };
  },
  mounted() {
    this.$emit("change", this.userInfo?.mobile);
    this.selectedCountry = this.countries[0];
  },

  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO,
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    mobileData() {
      this.mobileInput = this.userInfo?.mobile;
      return this.userInfo?.mobile;
    },
    isMobileVerify() {
      return this.userVerifyInfo?.is_mobile_verified === true;
    },
    isMobileValid() {
      if (this.mobileInput) {
        const mobileRegex = /^(09)\d{9}/;
        return mobileRegex.test(this.mobileInput);
      }
      return false;
    },
    isMobileCodeValid() {
      if (this.mobileCode) {
        const phoneRegex = /^\d{1,6}$/;
        return phoneRegex.test(this.mobileCode);
      }
      return true;
    }
  },
  methods: {
    ...mapActions({
      setMobile: types.userVerifyInfo.actions.SET_MOBILE_STATUS,
      setVerifyData: types.userVerifyInfo.actions.SET_USER_VERIFY_INFO,
      setUserData: types.userInfo.actions.ACTION_USER_INFO
    }),
    changeCountry() {
      this.$emit("changeCountry", this.selectedCountry);
    },
    verifyMobile() {
      if (this.isMobileCodeValid) {
        this.$emit("verifyMobile", this.mobileCode);
        // ContactService.verifyMobile(this.mobileCode)
        // .then(res => {
        // this.setMobile("VERIFIED");
        // console.log(res);
        // this.getAuthVerifyInfo();
        // this.getUserInfo();
        // this.closeMobileModal();
        // this.$toast.success(res.data.message);
        // })
        // .finally(() => this.finishRequest());
        // this.startRequest();
      }
    },
    closeMobileModal() {
      this.isModalOpen = false;
    },
    startRequest() {
      this.isRequesting = true;
    },
    handleFinishCountDown() {
      this.isCountDownFinish = true;
      this.ttl = 0;
    },
    resetCounter() {
      this.isCountDownFinish = false;
    },
    openVerifyMobile() {
      this.activeMobile();
      this.isModalOpen = true;
    },
    activeMobile() {
      if (this.mobileInput) {
        ContactService.activeMobile(this.mobileInput)
          .then(res => {
            this.ttl = res.data.data.ttl;
            this.resetCounter();
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },
    reActiveMobile() {
      ContactService.activeMobile(this.mobileInput)
        .then(res => {
          this.ttl = res.data.data.ttl;
          this.resetCounter();
        })
        .finally(() => this.finishRequest());
      this.startRequest();
    },
    finishRequest() {
      this.isRequesting = false;
    },
    getAuthVerifyInfo() {
      UserService.getVerifyInfo().then(response => {
        this.setVerifyData(response.data.data);
      });
    },
    getUserInfo() {
      UserService.getInfo().then(response => {
        this.setUserData(response.data.data);
      });
    }
  },
  watch: {
    mobileInput(newValue, oldValue) {
      const value = this.$enDigits(newValue);
      const digitReg = /^\d+$/;
      const isDigit = digitReg.test(value);
      if (newValue) {
        this.$emit("change", this.mobileInput);
        if (!isDigit) {
          this.mobileInput = oldValue;
        }
      }
    },
    isModalOpen(newValue) {
      if (newValue) {
        this.activeMobile();
      }
    }
  }
};
